import React from "react";
import './prize.css'
import silver from './media/silver.png'
import gold from './media/gold.png'
import bronze from './media/bronze.png'

const Prize = () => {
    return (
        <div className="prizes">
            <div className="title">
                <p>PRIZES</p>
            </div>
            <div className="prize_grp">
                <div className="second">
                    <div className="second_icon">
                        <img src={silver} alt="2nd" />
                    </div>
                    <div className="prize_cntnt">
                        <p className="second_title">
                            First Runner Up
                        </p>
                        <p className="second_cash">
                            Rs. 750
                        </p>
                        <p className="second_content">
                            Trophy + Certificate
                        </p>
                    </div>
                </div>
                <div className="first">
                    <div className="first_icon">
                        <img src={gold} alt="1st" />
                    </div>
                    <div className="prize_cntnt">
                        <p className="first_title">
                            W I N N E R
                        </p>
                        <p className="first_cash">
                            Rs. 1000
                        </p>
                        <p className="first_content">
                            Trophy + Certificate
                        </p>
                    </div>
                </div>
                <div className="third">
                    <div className="third_icon">
                        <img src={bronze} alt="3rd" />
                    </div>
                    <div className="prize_cntnt">
                        <p className="third_title">
                            Second Runner Up
                        </p>
                        <p className="third_cash">
                            Rs. 500
                        </p>
                        <p className="third_content">
                            Trophy + Certificate
                        </p>
                    </div>
                </div>
            </div>
            <p className="note">The Digital Certificate will be given to every participants.</p>
        </div>
    );
}

export default Prize;